export const billingSettings = {
  billingCycles: [
    {
      value: "All",
      label: "All",
    },
    {
      value: "Day",
      label: "Day",
    },
    {
      value: "Week",
      label: "Week",
    },
    {
      value: "Month",
      label: "Month",
    },
    {
      value: "Year",
      label: "Year",
    },
    {
      value: "Quarterly",
      label: "Quarterly",
    },
    {
      value: "Half-yearly",
      label: "Half-yearly",
    },
  ],
  discountTypes: [
    {
      value: "Percent",
      label: "Percent",
    },
    {
      value: "Flat",
      label: "Flat",
    },
  ],
  status: [
    {
      value: "Active",
      label: "Active",
    },
    {
      value: "Inactive",
      label: "InActive",
    },
    {
      value: "Draft",
      label: "Draft",
    },
  ],
  origins: [
    {
      value: "MySQL",
      label: "MySQL",
    },
    {
      value: "GSheets",
      label: "GSheets",
    },
    {
      value: "MongoDB",
      label: "MongoDB",
    },
    {
      value: "API LINK",
      label: "Get API Link",
    },
  ],
  feeTypes: [
    {
      value: "Fixed",
      label: "Fixed",
    },
    {
      value: "Usage Based",
      label: "Usage Based",
    },
  ],
  collectionTypes: [
    {
      value: "One Time",
      label: "One Time",
    },
    {
      value: "Recurring",
      label: "Recurring",
    },
  ],
  WalletTypes: [
    {
      value: "Individual Wallet",
      label: "Individual Wallet",
    },

    {
      value: "Combined Wallet",
      label: "Combined Wallet",
    },
  ],
  WalletLevels: [
    {
      value: "Subscription Level",
      label: "Subscription Level",
    },
    {
      value: "Customer Level",
      label: "Customer Level",
    },
  ],
  BillsOn: [
    {
      value: "Fixed Billing",
      label: "Fixed Billing",
    },

    {
      value: "Wallet Expiry",
      label: "Wallet Expiry",
    },
  ],
  calculationTypes: [
    {
      value: "min",
      label: "min",
    },
    {
      value: "max",
      label: "max",
    },
    {
      value: "count",
      label: "count",
    },
    {
      value: "avg",
      label: "avg",
    },
    {
      value: "sum",
      label: "sum",
    },
  ],
  EitherOrTypes: [
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ],
  ChargesTypes: [
    {
      value: "Pay Before Use",
      label: "Pay Before Use",
    },
    {
      value: "Next Cycle",
      label: "Next Cycle",
    },
  ],
  InvoiceTypes: [
    {
      value: "Combined for company",
      label: "Combined for company",
    },
    {
      value: "Separate for Subscription",
      label: "Separate for Subscription",
    },
  ],
  actions: [
    {
      value: "Pause usage",
      label: "Pause usage",
    },
    {
      value: "Allow usage",
      label: "Allow usage",
    },
  ],
};

export const billingCycles = [
  "Daily",
  "Weekly",
  "Monthly",
  "Quarterly",
  "Half-yearly",
  "Yearly",
];

export const pricingModels = [
  "Flat Fee",
  "Per Unit",
  "Volume",
  "Tiered",
  "Percent",
];

export const discountTypes = ["Percent", "Flat"];

export const onUpsellOptions = [
  "Raise invoice",
  "charge on next cycle as overage",
];
export const changesEffectiveOptions = ["immediate", "delayed", "contract"];

export const calculationTypes = ["min", "max", "count", "avg", "sum"];
export const paymentMethods = ["DigitalPaymentMethods", "BankTransfers"];
export const invoiceStatuses = ["Pending", "Paid"];
export const collectionTypes = ["One Time", "Recurring"];
export const origins = ["MySQL", "Get API Link", "GSheets", "MongoDB"];
const industryNames = [
  "Agriculture",
  "Manufacturing",
  "Construction",
  "Retail",
  "Healthcare",
  "Finance and Insurance",
  "Information Technology",
  "Telecommunications",
  "Transportation and Logistics",
  "Hospitality and Tourism",
  "Real Estate",
  "Energy and Utilities",
  "Education",
  "Entertainment and Media",
  "Pharmaceuticals",
  "Automotive",
  "Food and Beverage",
  "Aerospace and Defense",
  "Biotechnology",
  "Textiles and Apparel",
  "E-commerce and Online Retail",
  "Renewable Energy",
  "Artificial Intelligence and Machine Learning",
  "Blockchain and Cryptocurrency",
  "Space Exploration and Commercialization",
  "Quantum Computing",
  "Virtual Reality and Augmented Reality",
  "Cybersecurity",
  "Robotics and Automation",
  "Waste Management and Recycling",
  "Sustainable and Green Technologies",
  "Health Tech and Wearable Devices",
  "Genomics and Precision Medicine",
  "Smart Cities and IoT",
  "Esports and Gaming",
  "Electric Vehicles and Battery Technology",
  "EdTech and Online Learning Platforms",
  "FoodTech and Agritech",
  "Clean Water and Sanitation Solutions",
  "Digital Marketing and Social Media Management",
  "Subscription Services and D2C Brands",
];

export const industries = industryNames.map((name, index) => ({
  id: index + 1,
  name,
}));

/**
 * The Industry select field expects an `{id, name}` object (`isObject: true`,
 * `valueSelector: "id"` in useResolveFormSchema.js), but the backend stores
 * plain string names - so an edit form's initial value always needs this
 * lookup+fallback. Was hand-duplicated 3x (CompanyPage, CompanyDetails,
 * usePayPage), and the Pay page's copy was missing the fallback entirely -
 * any stored industry name not exactly matching this static list (a legacy
 * value, or one added/renamed here since) collapsed to `undefined`, leaving
 * the field blank and failing required-field validation even though the
 * company genuinely had an industry on file.
 */
export const resolveIndustryValue = (industryName) => {
  if (!industryName) return undefined;
  return (
    industries.find((industry) => industry.name === industryName) || {
      id: industries.length + 1,
      name: industryName,
    }
  );
};
